import React, {useEffect, useImperativeHandle, useRef} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import utils from 'helpers/utils';
import StyledBrowserBar from 'components/organisms/Bars/BrowserBar/BrowserBar.styles';
import dom from 'helpers/dom';

const BrowserBar = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'BrowserBar');

  const innerRef = useRef(null);

  useImperativeHandle(ref, () => innerRef.current);

  useEffect(() => {
    const scroll = () => {
      const contentEl = innerRef.current?.refs?.ref?.current?.parentElement?.children?.[1];
      dom.scrollIntoView(contentEl, {align: 'top', behavior: 'instant'});
    };

    return utils.observeRetry(scroll, 5);
  }, []);

  innerProps.className = utils.flattenClassName(innerProps.className);

  return <StyledBrowserBar ref={innerRef} {...innerProps}/>
});

BrowserBar.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default BrowserBar;
